var _rect, _path, _path2, _path3, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path4, _path5, _ellipse, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.419 257.762C232.383 266.358 230.852 276.533 222.256 281.497C213.659 286.46 204.082 282.698 199.119 274.101C194.156 265.504 197.915 254.042 204.282 250.366C210.65 246.69 222.456 249.165 227.419 257.762Z",
    fill: "#1C1B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.581 257.762C297.618 266.358 299.148 276.533 307.744 281.497C316.341 286.46 325.918 282.698 330.881 274.101C335.845 265.504 332.085 254.042 325.718 250.366C319.35 246.69 307.544 249.165 302.581 257.762Z",
    fill: "#1C1B1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0002 322C79.0847 320.037 196.5 295.5 400 149.078",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 210.149,
    y: 206,
    width: 65.9939,
    height: 77.9928,
    rx: 8,
    transform: "rotate(45 210.149 206)",
    fill: "#D9D9D9",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 211.982,
    cy: 234.892,
    r: 5.61795,
    fill: "#1C1B1F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.033,
    cy: 249.339,
    r: 5.61795,
    fill: "#1C1B1F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.09,
    cy: 258.97,
    r: 5.61795,
    fill: "#1C1B1F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.536,
    cy: 246.128,
    r: 5.61795,
    fill: "#1C1B1F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.587,
    cy: 260.574,
    r: 5.61795,
    fill: "#1C1B1F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.141,
    cy: 273.415,
    r: 5.61795,
    fill: "#1C1B1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.143 140C122.409 140.97 104.758 147.143 101.134 164.032C100.845 165.381 99.7771 166.454 98.4126 166.659C77.4895 169.798 43.6788 184.989 57.4282 224.147C57.8468 225.34 57.5328 226.694 56.6019 227.548C36.7792 245.743 12.6299 287.322 62.5684 320.339C63.5621 320.996 64.1244 322.181 63.9773 323.363C60.9477 347.713 69.2033 390.124 125.813 379.251C125.982 379.219 126.154 379.171 126.315 379.109C147.52 370.932 168.804 349.64 157.495 305.211",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M397.566 140C406.3 140.97 423.951 147.143 427.575 164.032C427.864 165.381 428.932 166.454 430.296 166.659C451.219 169.798 485.03 184.989 471.281 224.147C470.862 225.34 471.176 226.694 472.107 227.548C491.93 245.743 516.079 287.322 466.141 320.339C465.147 320.996 464.585 322.181 464.732 323.363C467.761 347.713 459.506 390.124 402.896 379.251C402.727 379.219 402.555 379.171 402.394 379.109C381.189 370.932 359.905 349.64 371.214 305.211",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.065,
    cy: 315.503,
    rx: 31.7638,
    ry: 17.5025,
    fill: "#1C1B1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195 347.266C212.243 325.806 271.233 295.565 331.131 347.266",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/안과-dog.78b21ce27935cd493df165396cfc6252.svg";
export { ForwardRef as ReactComponent };